export var MetadataFieldNames;
(function (MetadataFieldNames) {
    MetadataFieldNames["formTitle"] = "formTitle";
    MetadataFieldNames["filename"] = "filename";
    MetadataFieldNames["competitor"] = "competitor";
    MetadataFieldNames["formNumber"] = "formNumber";
    MetadataFieldNames["fileid"] = "fileid";
})(MetadataFieldNames || (MetadataFieldNames = {}));
